import { Injectable } from '@angular/core';
import { FeatureHandlerService } from './handlers/feature-handler.service';
@Injectable({
  providedIn: 'root'
})
export class FeaturesService {

  constructor(
    private FeatureHandlerService: FeatureHandlerService,
  ) { }

  getAll(){
    return this.FeatureHandlerService.getAll();
  }

}
